import React, { useState, useEffect } from "react";
import mainLogo from "../images/mainLogo2.png";
import cookies from "js-cookie";
import { RiHome6Line } from "react-icons/ri";
import { RxDashboard } from "react-icons/rx";
import { TbMap2 } from "react-icons/tb";
import { SlLocationPin } from "react-icons/sl";
import { VscInfo } from "react-icons/vsc";
import { MdMiscellaneousServices } from "react-icons/md";
import { AiOutlineMenu } from "react-icons/ai";
import { useTranslation } from "react-i18next";
import { RxCross2 } from "react-icons/rx";
import i18next from "i18next";

import { languages } from "../App";

const Navbar = () => {
  const [showNav, setShowNav] = useState(false);

  const { t } = useTranslation();
  const currentLangCode = cookies.get("i18next") || "en";
  const currentLang = languages.find((l) => l.code === currentLangCode);
  useEffect(() => {
    document.body.dir = currentLang.dir || "ltr";
  }, [currentLang]);
  return (
    <div className=" tw-relative">
      <div className="tw-absolute tw-top-0 tw-right-0 tw-p-4 tw-w-full tw-z-10 tw-flex tw-justify-center">
        <div className="tw-flex tw-justify-between tw-items-center tw-w-[85%] lg:tw-w-[90%]">
          <div className=" tw-w-[100px] lg:tw-w-[80px] sm:tw-w-[70px] xs:tw-w-[60px] ">
            <img src={mainLogo} className="tw-w-full" />
          </div>
          <div
            className="tw-hidden md:tw-block tw-p-3 tw-text-2xl tw-text-white tw-shadow-md tw-rounded-md tw-cursor-pointer hover:tw-bg-third-gold hover:tw-text-white"
            onClick={() => setShowNav(true)}
          >
            <span>
              <AiOutlineMenu />
            </span>
          </div>
          <div
            className={`md:tw-absolute tw-right-0 ${
              showNav ? "tw-top-0" : "tw-top-[-1000px]"
            } md:tw-w-full md:tw-h-screen md:tw-z-4 md:tw-bg-transparent-black tw-transition-all tw-duration-500 tw-ease-in-out`}
          >
            <div className="tw-flex tw-items-center md:tw-flex-col md:tw-items-start tw-gap-5 lg:tw-gap-2 md:tw-w-[80%] md:tw-p-3 md:tw-pt-9 md:tw-h-screen md:tw-bg-white md:tw-relative">
              <span
                className="tw-hidden md:tw-block md:tw-absolute tw-top-3 tw-right-3 tw-p-3 tw-shadow-sm hover:tw-text-red-600 tw-cursor-pointer hover:tw-bg-gray-50 tw-rounded-md tw-text-xl"
                onClick={() => setShowNav(false)}
              >
                <RxCross2 />
              </span>
              <a
                href="#main"
                className="tw-flex tw-items-center tw-capitalize tw-gap-2 tw-text-white tw-p-4 tw-cursor-pointer tw-text-lg lg:tw-text-sm tw-font-semibold md:tw-font-normal xs:tw-font-thin md:tw-shadow-sm md:tw-bg-gray-50 md:tw-text-gray-600 hover:md:tw-pr-7 tw-whitespace-nowrap hover:tw-bg-third-gold  tw-rounded-md hover:md:tw-text-white md:tw-w-full xs:tw-text-sm tw-transition-all tw-duration-500 tw-ease-in-out md:tw-mt-10"
                onClick={() => setShowNav(false)}
              >
                <span className="tw-text-2xl lg:tw-text-sm sm:tw-text-xl">
                  <RiHome6Line />
                </span>
                <span>{t("link1")}</span>
              </a>
              <a
                href="#comm"
                className="tw-flex tw-items-center tw-capitalize tw-gap-2 tw-text-white tw-p-4 tw-cursor-pointer tw-text-lg lg:tw-text-sm tw-font-semibold md:tw-font-normal xs:tw-font-thin md:tw-shadow-sm md:tw-bg-gray-50 md:tw-text-gray-600 hover:md:tw-pr-7 tw-whitespace-nowrap hover:tw-bg-third-gold tw-rounded-md hover:md:tw-text-white md:tw-w-full xs:tw-text-sm tw-transition-all tw-duration-500 tw-ease-in-out"
                onClick={() => setShowNav(false)}
              >
                <span className="tw-text-2xl lg:tw-text-sm sm:tw-text-xl">
                  <RxDashboard />
                </span>
                <span>{t("link2")}</span>
              </a>
              <a
                href="#loc"
                className="tw-flex tw-items-center tw-capitalize tw-gap-2 tw-text-white tw-p-4 tw-cursor-pointer tw-text-lg lg:tw-text-sm tw-font-semibold md:tw-font-normal xs:tw-font-thin md:tw-shadow-sm md:tw-bg-gray-50 md:tw-text-gray-600 hover:md:tw-pr-7 tw-whitespace-nowrap hover:tw-bg-third-gold tw-rounded-md hover:md:tw-text-white md:tw-w-full xs:tw-text-sm tw-transition-all tw-duration-500 tw-ease-in-out"
                onClick={() => setShowNav(false)}
              >
                <span className="tw-text-2xl lg:tw-text-sm sm:tw-text-xl">
                  <TbMap2 />
                </span>
                <span>{t("link3")}</span>
              </a>

              <a
                href="#company"
                className="tw-flex tw-items-center tw-capitalize tw-gap-2 tw-text-white tw-p-4 tw-cursor-pointer tw-text-lg lg:tw-text-sm tw-font-semibold md:tw-font-normal xs:tw-font-thin md:tw-shadow-sm md:tw-bg-gray-50 md:tw-text-gray-600 hover:md:tw-pr-7 tw-whitespace-nowrap hover:tw-bg-third-gold tw-rounded-md hover:md:tw-text-white md:tw-w-full xs:tw-text-sm tw-transition-all tw-duration-500 tw-ease-in-out"
                onClick={() => setShowNav(false)}
              >
                <span className="tw-text-2xl lg:tw-text-sm sm:tw-text-xl">
                  <VscInfo />
                </span>
                <span>{t("link4")}</span>
              </a>
            </div>
          </div>
          <div>
          {languages.map((lang, index) => (
            <button
              key={index}
              disabled={lang.code === currentLangCode}
              className={` ${
                lang.code === currentLangCode ? "tw-hidden" : ""
              } tw-bg-third-gold tw-p-2 tw-px-4 tw-rounded-md tw-text-white tw-shadow-md hover:tw-bg-white hover:tw-text-main-dark tw-duration-500 `}
              onClick={() => {
                // localStorage.setItem('langCode' , e.target.value);
                // i18next.changeLanguage(e.target.value);
                i18next.changeLanguage(lang.code);
              }}
            >
              {lang.name}
            </button>
          ))}
        </div>
        </div>
        
      </div>
    </div>
  );
};

export default Navbar;
